import script from "./PendingRequest.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingRequest.vue?vue&type=script&setup=true&lang=js"

import "./PendingRequest.vue?vue&type=style&index=0&id=3d72897b&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d72897b"]])

export default __exports__